import React from 'react';
import RCore from 'RCore';
import config from 'cfg';
import SMStream from '../SMStream';
import moment from 'moment';
import _ from 'lodash';

class TournamentAnnouncesSMStream extends SMStream {
    renderToolbar() {
        let { events = [] } = this.state;
        return [
            <div key="hotlinks">
                {events.map(e => {
                    return (
                        <a key={e.eventId}>
                            {e.home} - {e.away}
                        </a>
                    );
                })}
            </div>,
            <h1 key="title">Tournament coming & latest matches</h1>
        ];
    }

    loadSMWidgets = params => {
        let { tournamentId, seasonId, round } = params;

        let { tournament, events } = params;

        let hasPro = RCore.isProStatsDataAvailable(tournamentId, seasonId);

        return RCore.promiseProps({
            events:
                events ||
                fetch(
                    `${config.apis.ss2}/events-v2/?ttId[]=${tournamentId}&seasonId=${seasonId}&fromDate=${moment()
                        .add('days', -2)
                        .format('YYYY-MM-DD')}&limit=12`
                )
                    .then(response => response.json())
                    .then(res => res.events),
            tournament:
                tournament || fetch(`${config.apis.ss2}/tournaments/${tournamentId}`).then(response => response.json())
        }).then(result => {
            let { tournament } = result;
            let round = parseInt(tournament.currentRound, 10);
            var daysWithMatches = _.groupBy(result.events, m => moment(m.startDate).format('YYYY-MM-DD'));

            var finishedMatches = _.filter(result.events, e => e.statusType === 'finished');
            var liveMatches = _.filter(result.events, e => e.statusType === 'inprogress');
            var commingMatches = _.filter(result.events, e => e.statusType === 'notstarted');

            var matchDays = Object.keys(daysWithMatches).map(date => {
                return {
                    name: 'TodayMatchesSMWidget',
                    groupTitle: 'Matches by date',
                    groupDesc: 'Widgets that are representing bla-bla',
                    props: {
                        'data-tournament-id': tournamentId,
                        date: date
                    },
                    key: `${date + '_' + tournamentId}`
                };
            });
            return _.compact([
                ...matchDays,

                round > 1 && {
                    name: 'RoundMatchesSMWidget',
                    groupTitle: 'Matches by round',
                    groupDesc: 'Browse nearest rounds',
                    props: {
                        'data-tournament-id': tournamentId,
                        'data-round': round - 1,
                        'data-group-by-day': !hasPro
                    },
                    key: `round-1-${tournamentId}`
                },
                {
                    name: 'RoundMatchesSMWidget',
                    groupTitle: 'Matches by round',
                    groupDesc: 'Browse nearest rounds',
                    props: {
                        'data-tournament-id': tournamentId,
                        'data-group-by-day': !hasPro
                    },
                    key: `round-${tournamentId}`
                },
                {
                    name: 'RoundMatchesSMWidget',
                    groupTitle: 'Matches by round',
                    groupDesc: 'Browse nearest rounds',
                    props: {
                        'data-tournament-id': tournamentId,
                        'data-round': round + 1,
                        'data-group-by-day': !hasPro
                    },
                    key: `round+1-${tournamentId}`
                },
                ...finishedMatches.map(
                    e =>
                        hasPro && {
                            name: 'ProLiveMatchStatsSMWidget',

                            groupTitle: 'Finished matches stats',
                            groupDesc: 'Latest matches',

                            props: {
                                'data-event-id': e.eventId
                            },
                            key: `mp-${e.eventId}`
                        }
                ),
                ...finishedMatches.map(e => ({
                    groupTitle: 'Finished matches',
                    groupDesc: 'Latest matches',

                    name: 'MatchFinished',
                    props: {
                        'data-event-id': e.eventId
                    },
                    key: `mp-${e.eventId}`
                })),
                ...finishedMatches.map(e => ({
                    groupTitle: 'MatchStats',
                    groupDesc: 'Latest matches',

                    name: 'MatchStats',
                    props: {
                        'data-event-id': e.eventId
                    },
                    key: `ms-${e.eventId}`
                })),
                ...commingMatches.map(e => ({
                    name: 'PreMatchStatsSMWidget',
                    groupTitle: 'Upcoming matches H2H',
                    groupDesc: '...',

                    props: {
                        'data-event-id': e.eventId
                    },
                    key: `h2h-${e.eventId}`
                }))
            ]);
        });
    };
}

export default TournamentAnnouncesSMStream;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/streams/tournament/TournamentAnnouncesSMStream.js
 **/